// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uOGu0","pageTitle":"styles_pageTitle__HRtV5","actionsContainer":"styles_actionsContainer__FzhGS","tableContainer":"styles_tableContainer__ssirY"};